<template>
  <a-menu theme="dark" mode="inline"
          @click="handleRoute"
          :default-active="activeRoute"
          :inline-collapsed="isCollapse">
    <template v-for="item in menu.data">
      <a-menu-item v-if="!item.children || item.children.length===0" :key="item.path || item.id">
        <a-icon v-if="item.icon" :type="item.icon"/>
        <span>{{ $t(item.code) || item.name }}</span>
      </a-menu-item>
      <sub-menu v-else :key="item.path||item.id" :menu-info="item"/>
    </template>
  </a-menu>
</template>
<script>
import { _treeGenerator } from '@/api/sys/sysMenuApi';
import SubMenu from '@/components/SubMenu.vue';

export default {
  components: {
    SubMenu,
  },
  name: 'SideBar',
  props: {
    isCollapse: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      menu: {
        data: [],
      },
      activeRoute: [this.$route.fullPath],
    };
  },
  methods: {
    handleRoute({ item, key, keyPath }) {
      this.$router.push({ path: key });
    },
    handleOpen(key, keyPath) {
    },
    handleClose(key, keyPath) {
    },
  },
  created() {
    const menus = JSON.parse(localStorage.getItem('MENUS'));
    this.menu.data = menus
      .filter(x => !x.parentId)
      .map(x => _treeGenerator(x, menus));
  },
};
</script>

<style scoped>

</style>
